interface IMarketFlucRange {
  upper_limit: number;
  lower_limit: number;
  message: string;
}

class MarketFlucRange implements IMarketFlucRange {
  upper_limit: number;
  lower_limit: number;
  message: string;

  constructor(params: Partial<IMarketFlucRange>) {
    this.upper_limit = params?.upper_limit ?? 0;
    this.lower_limit = params?.lower_limit ?? 0;
    this.message = params?.message ?? '';
  }

  /** from json to class instance */
  static fromJson(json: any): MarketFlucRange {
    return new MarketFlucRange(json);
  }
}

export default MarketFlucRange;
